<span class="qa-bibliographic-resource-type">{{
  BibliographicResourceTypeLocaleLabels[resourceType]
}}</span>
